import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { FiChevronDown } from 'react-icons/fi'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab4 = ({pageState,setPageState,handleChange,onInputChange,
    setPrimaryadd, primaryadd, addaresslist,
    contactlist, primarycontact, setPrimarycontact,customerName

}) => {
    const [isGroup, setIsGroup] = useState(0)


    return (
       <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Primary Address</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                   <SelectSearch
                            list={addaresslist || []}
                            label="Customer Primary Address"
                           
                             value={pageState.primaryadd}
                      onChange={(val) => handleChange('primaryadd', val)}
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="Customer Primary Address"
                            createNewUrl = '/master/address/create-address'
                            createNewLabel = 'Create New Address'

                        />
                  <p
                    style={{
                      // paddingLeft: "14px",
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      lineHeight: '2',
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    Reselect, if the chosen address is edited after save
                  </p>

                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Primary Contact</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                   <SelectSearch
                            list={contactlist || []}
                            label="Customer Primary Contact"
                             value={pageState.primarycontact}
                      onChange={(val) => handleChange('primarycontact', val)}
                           
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="Customer Primary Contact"
                        />
                  <p
                    style={{
                      // paddingLeft: "14px",
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      lineHeight: '2',
                      fontSize: "9px",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    Reselect, if the chosen contact is edited after save
                  </p>


                </div>

              </div>




            </div>
          </div>
        </div>
          <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Customer" docname={customerName} />
            </div>
          </div>
        </div>
      </div>

    </div>
    )
}

export default Tab4